
export abstract class AnswerValue {
  constructor(public label : string) {}
  abstract copy() : AnswerValue;
  isValid() : boolean {
    return this.label &&
      this.label.length > 0;
  }

  equals(other : AnswerValue) : boolean {
    return this.label == other.label;
  }
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/model/answer-value.ts